import React from 'react';

import Rocksport2024 from 'views/Rocksport2024';

const SchoolProgrampage = () => {
  return <Rocksport2024 />;
};

export default SchoolProgrampage;